<template>
  <div v-if="getStorePickUpInfo">
    {{ getStorePickUpInfo }}
  </div>
  <div v-if="getDeliveryType">
    {{ getDeliveryType }}
  </div>
</template>

<script>
export default {
  name: 'ShippingOptions',
  props: {
    shippingType: {
      type: Object,
      default: () => {},
    },
    flags: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    //   TODO:check with api team if there are different responses for bopsFreePickUpMessage and curbsideFreePickUpMessage.
    getStorePickUpInfo() {
      if (this?.flags?.showBopsStoreBadge || this?.flags?.showBossStoreBadge) {
        if (
          this.shippingType?.bopsFreePickUpMessage === 'Free Pickup Today'
          || this.shippingType?.curbsideFreePickUpMessage
            === 'Free Pickup Today'
        ) {
          return 'Free Pickup Today';
        }
      }
      return null;
    },
    getDeliveryType() {
      if (this.flags?.showSddStoreBadge && this.shippingType?.sddMessage) {
        return this.shippingType?.sddMessage;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
